export const brandColor = process.env.REACT_APP_BRAND_COLOR || '#005282'
